import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { AccountService } from "@/services/AccountService"

// All accounts (current and ceased) that have held the site's Junifer property.
// Resolved from the viewed account's junifer property id, then a single
// accounts-by-property read against be-ac-junifer. This replaces the retired ark
// `junifer_accounts` occupancy walk (meterpoint-by-meterpoint recursion), which
// disappeared when Meterpoints moved off Ruby/ark.
export const getSupplyAddressAccounts = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const accountQuery = AccountService.getAccount(accountNumber)
  queries.add(accountQuery)

  const propertyId = accountQuery.data?.juniferPropertyId ?? null
  const accountsQuery = AccountService.getAccountsByProperty(propertyId)
  queries.add(accountsQuery)

  return queries.setData(accountsQuery.data ?? []).getAggregate()
}
